import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { UserService } from '../../services/user.service';
import { debounce, Observable, of, startWith, timer } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { PermissionService } from '../../services/permission.service';
import { ACTION, SUBJECT } from '../../enums';

@Component({
  selector: 'app-add-button',
  templateUrl: './add-button.component.html',
  styleUrl: './add-button.component.scss'
})
export class AddButtonComponent {
  protected readonly ACTION = ACTION;
  protected readonly SUBJECT = SUBJECT;

  toggleTooltip = new EventEmitter<boolean>();
  isTooltipOpened$: Observable<boolean> = this.toggleTooltip.asObservable().pipe(
    debounce(ev => !ev ? timer(600) : of(ev)),
    startWith(false)
  )

  @Input({ transform: booleanAttribute }) disabled: boolean = false;
  @Input({ transform: booleanAttribute }) tooltipDisabled: boolean = false;
  @Output() clicked = new EventEmitter<MouseEvent>();

  constructor(
    private dialogService: MatDialog,
    protected companyService: CompanyService,
    protected userService: UserService,
    protected permissionService: PermissionService
  ) {}

  onClick(event: MouseEvent) {
    this.clicked.emit(event);
  }

  async selectPlan(): Promise<void> {
    const { ChangePlanModalComponent } = await import('../modals/subscription/change-plan-modal/change-plan-modal.component');
    const company = this.companyService.companyInfo$.getValue();

    if (!company) {
      return;
    }

    this.dialogService.open(ChangePlanModalComponent, {
      panelClass: ['dialog-overlay-pane'],
      width: '590px',
      data: {
        companyId: company.id,
        discount: company.billing?.discountPercentage
      }
    });
  }
}
